import Axios from 'axios'
import { Dispatch } from 'redux'

import { ActionResponse, Id } from 'util/types/index'
import { PartnerProduct, PartnerProductTypes } from '../types'
import { clearAlert, createAlert, handleError } from 'util/modules/Alert/redux/actions'

type UpdateOpts = { isActive: boolean, order: number, cheaper: number, cashback: number }

export function updatePartnerProduct (partnerId: Id, id: Id, data: Partial<UpdateOpts>) {
  return async (dispatch: Dispatch): Promise<ActionResponse<PartnerProduct>> => {
    return Axios
      .put(`/partner/${partnerId}/product/${id}/config`, data)
      .then(res => res.data)
      .then(async res => {
        if (res?.status === 'success') {
          dispatch({ type: PartnerProductTypes.PARTNER_PRODUCT_GET, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao atualizar o produto')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function deletePartnerProduct (partnerId: Id, productId: Id) {
  return async (dispatch: Dispatch): Promise<ActionResponse<PartnerProduct>> => {
    return Axios
      .delete(`/partner/${partnerId}/product/${productId}/config`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: PartnerProductTypes.PARTNER_PRODUCT_DELETE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao remover o produto')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function getPartnerProduct (partnerId: Id, id: Id) {
  return async (dispatch: Dispatch): Promise<ActionResponse<PartnerProduct>> => {
    return Axios
      .get(`/partner/${partnerId}/product/${id}/config`)
      .then(res => res.data)
      .then(res => {
        dispatch({ type: PartnerProductTypes.PARTNER_PRODUCT_GET, payload: res.data })
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao buscar o produto')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function getPartnerProductList (partnerId: Id) {
  return async (dispatch: Dispatch): Promise<ActionResponse<PartnerProduct[]>> => {
    return Axios
      .get(`/partner/${partnerId}/products`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: PartnerProductTypes.PARTNER_PRODUCT_GET_LIST, payload: res.data })
        }
        return res
      })
  }
}
